export default {
 table:{},
 tab:[],
 renderDetail:{},
 detailData:{},
 tabActive:{},
 page:{},
 column:{},
 data:{},
 sidebar:false,
 language:[],
 banner:{},
 start_end:{},
 isPublish:null,
 content:{},
 type:{}

};
